import React from 'react';

const RefundPolicy = () => {
    return (
        <>
            <style>{`
                body {
                    background-color: #121212;
                    color: #e0e0e0;
                    font-family: 'Inter', sans-serif;
                }

                .legal-container {
                    background-color: #1f1f1f;
                    padding: 2rem;
                    border-radius: 0.5rem;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
                    max-width: 900px;
                    margin: 2rem auto;
                    color: #a5a6ad;
                    font-size: 0.95rem;
                    line-height: 1.6;
                }

                .company-name {
                    font-size: 1.2rem;
                    font-weight: 500;
                    color: #9e9e9e;
                    margin-bottom: 0.5rem;
                    display: block;
                }
                
                .legal-container h2 {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #ffffff;
                    border-bottom: 2px solid #333;
                    padding-bottom: 0.75rem;
                    margin-bottom: 2rem;
                }
                
                .legal-container h3 {
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: #f0f0f0;
                    margin-top: 2.5rem;
                    margin-bottom: 1rem;
                }
                
                .legal-container p {
                    margin-bottom: 1.2rem;
                    color: #b0b0b0;
                }

                .legal-container ol {
                    list-style-type: none;
                    padding-left: 0;
                    margin-bottom: 1rem;
                    counter-reset: list-counter;
                }
                
                .legal-container li {
                    position: relative;
                    padding-left: 1.5rem;
                    margin-bottom: 0.75rem;
                    color: #b0b0b0;
                    counter-increment: list-counter;
                }

                .legal-container li::before {
                    content: counter(list-counter) '.';
                    color: #4a90e2;
                    position: absolute;
                    left: 0;
                    font-weight: bold;
                    font-size: 1rem;
                }
                
                .legal-container strong {
                    color: #ffffff;
                    font-weight: 600;
                }
                
                .legal-container .highlight {
                    background-color: #2a2a31;
                    padding: 1.5rem;
                    border-radius: 0.5rem;
                    border-left: 4px solid #4a90e2;
                    margin: 2rem 0;
                }
                
                .legal-container .highlight p {
                    color: #d0d0d0;
                    margin: 0;
                }
            `}</style>
            <div className="legal-container">
                <span className="company-name">CommunityofHubs</span>
                <h2>Refund Policy</h2>
                <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>

                <h3>Quiz Certificates</h3>
                <p>
                    At CommunityofHubs, we offer digital certificates upon the successful completion of our quizzes. This policy outlines our terms regarding payments and refunds for these certificates.
                </p>

                <div className="highlight">
                    <p>
                        <strong>All payments for quiz certificates are final and non-refundable.</strong>
                    </p>
                    <p>
                        Once a payment is made to obtain a certificate, you will not be eligible for a refund under any circumstances.
                    </p>
                </div>

                <h3>The Process</h3>
                <p>
                    Our process for obtaining a certificate is as follows:
                </p>
                <ol>
                    <li>You must successfully complete the quiz according to the specified requirements.</li>
                    <li>After completion, you will be prompted to make a payment to receive your official certificate.</li>
                    <li>Upon successful payment, your certificate will be generated and sent electronically to the email address associated with your account.</li>
                </ol>

                <h3>Reason for No Refunds</h3>
                <p>
                    Due to the immediate, digital nature of the certificates and the administrative costs associated with processing and delivering them, we are unable to offer refunds once a transaction is complete. By making a payment, you acknowledge and agree to this policy.
                </p>

                <h3>Issues with Delivery</h3>
                <p>
                    If you have successfully made a payment but have not received your certificate via email within 24 hours, please contact our support team. We will investigate the issue and ensure the certificate is delivered to you.
                </p>
                
                <h3>Contact Us</h3>
                <p>
                    For any questions regarding this policy or for issues with certificate delivery, please contact us at: <strong>support@communityofhubs.com</strong>
                </p>
            </div>
        </>
    );
};

export default RefundPolicy;